<div class="d-flex flex-column h-100">
    <div style="height:auto;" class="mapHeaderContainer">
        <map-header *ngIf="showMapHeader" [htmlContent]="mapHeaderHtml" [mapctrl]="vm"></map-header>
    </div>
    <div class="flex-fill">
        <div class="container-full " id="map-body-container">
            <!--map container-->

            <div print-section id="map" class="map"></div>

            <!--menu button-->
            <div id="pos-input-button-group" *ngIf="showMainMenu">
                <span class="input-group-btn">
                    <button class="btn focus collapsed toggle-btn" type="button" (click)="doColapseMenu()">
                        <span class="fa fa-bars"></span>
                    </button>
                </span>
            </div>
            <!--tools overlay-->
            <div id="overlay" class="overlay" *ngIf="showMainMenu">
                <!--layers config-->
                <map-layers [mapctrl]="vm"></map-layers>
                <!--tranzit-->
                <map-tranzit [mapctrl]="vm"></map-tranzit>
                <!--location-->
                <map-position [mapctrl]="vm"></map-position>
                <map-location-search-custom-b [mapctrl]="vm"></map-location-search-custom-b>
                <!--greentop-->
                <greentop-download [mapctrl]="vm"></greentop-download>
                <greentop-training [mapctrl]="vm"></greentop-training>
                <greentop-classify [mapctrl]="vm"></greentop-classify>
                <!--integrate-landsat-->
                <integrate-landsat-download [mapctrl]="vm"></integrate-landsat-download>
                <integrate-landsat-hotspot [mapctrl]="vm"></integrate-landsat-hotspot>
                <integrate-landsat-procesare-indice-conex [mapctrl]="vm"></integrate-landsat-procesare-indice-conex>
                <integrate-landsat-procesare-date-sezoniere [mapctrl]="vm"></integrate-landsat-procesare-date-sezoniere>
            </div>

            <!--bottom controls-->
            <map-bottomtop-controlbar [mapctrl]="vm"></map-bottomtop-controlbar>
            <!--map legend-->
            <map-legend [mapctrl]="vm"></map-legend>
            
            <!-- 3D Toggle Button -->
            <div id="toggle-3d-button" class="toggle-3d-btn" *ngIf="cesium3DButtonStateVisible">
                <button class="btn btn-light" 
                        (click)="toggle3D()" 
                        [disabled]="cesiumLoading"
                        [title]="is3DEnabled() ? 'Comutare la 2D' : 'Comutare la 3D'">
                    <i class="fas" [ngClass]="is3DEnabled() ? 'fa-map' : 'fa-globe'"></i>
                    <span *ngIf="!cesiumLoading">{{ is3DEnabled() ? '2D' : '3D' }}</span>
                    <i *ngIf="cesiumLoading" class="fa fa-spinner fa-spin"></i>
                </button>
            </div>
            
            <!--data loader-->
            <div id="layerLoading" class="button_wrapper" *ngIf="showLayerLoading()">
                <i id="spinner" class="fa fa-circle-o-notch fa-spin" style="font-size:24px"></i>
                <span> Încărcare hartă </span>
            </div>
            <!-- overlay -->
            <div style="display: none">
                <div id="location-marker">
                    <img src="img/location-marker.svg" alt="+" />
                </div>
            </div>
            <!-- Info feature -->
            <div id="info-popup"> </div>
        </div>
    </div>
    <div style="height: auto;" class="mapFooterContainer">
        <map-footer *ngIf="showMapFooter" [htmlContent]="mapFooterHtml"></map-footer>
    </div>
</div>